import React, { PureComponent } from "react";

import Video from "./Video";
import "./videos.css";
import videoArray from "./videos.json";

class VideosPage extends PureComponent {
  render() {
    return (
      <div>
        <div>
          <h1>Videos</h1>
        </div>

        <hr />

        <div
          style={{
            alignItems: "center"
          }}
        >
          {videoArray.map((video, index) => {
            const { videoId } = video;

            return (
              <div key={videoId}>
                <Video
                  //
                  video={video}
                />
                <hr />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default VideosPage;



// WEBPACK FOOTER //
// ./src/routes/videos/VideosPage.js